import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import styled from 'styled-components';

import { FullScreenError, Loader } from '@sine/sine-ui-components';

import oAuthRectifier from '../../shared/auth/oAuthRectifier.service';
import { oAuthResultStorage } from '../../shared/auth/oAuthResultStorage';

const CenteredDiv = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function OAuthRectifier() {
  const navigate = useNavigate();
  const [redirect, setRedirect] = useState<string | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    try {
      const oAuthResult = oAuthRectifier.retrieveOAuthResult();
      oAuthResultStorage.setLatestOAuthResult(oAuthResult);

      const location = oAuthResult.location;
      const redirectPath = location.pathname + location.search + location.hash;
      setRedirect(redirectPath);
    } catch (e) {
      if (e instanceof Error) {
        setError(e);
        return;
      }
    }
  }, []);

  if (error) {
    return (
      <FullScreenError
        type='unknown'
        actionText={'Back to plugins home'}
        onAction={() => {
          navigate('/plugins');
        }}
      >
        Failed to redirect after authorization
        <br />
        {error.toString()}
      </FullScreenError>
    );
  }
  return (
    <CenteredDiv>
      <Loader show={true} />
      {redirect && <Navigate replace to={redirect} />}
    </CenteredDiv>
  );
}
